import { styled } from '$utils/theme'
import { Container } from '$views/components/Layout/Container'
import { rem } from 'polished'

export const PaymentInfoContainer = styled(Container)`
  padding-top: 0;
`

export const ConditionsGrid = styled.div.attrs({})<Props>`
  display: grid;
  grid-template-columns: 30px auto;
  margin-top: ${p => rem(p.theme.sizes.base)};
`



// WEBPACK FOOTER //
// ./src/views/PaymentDetails/components/PaymentInfo/PaymentInfo.style.ts